export enum ImageType {
    ChannelProfile = "ChannelProfile",
    ChannelCover = "ChannelCover",
    UserProfile = "UserProfile",
}
